import { render } from "./edit-exam.vue?vue&type=template&id=01032dc4"
import script from "./edit-exam.vue?vue&type=script&lang=js"
export * from "./edit-exam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__